<template>
  <div class="page-task-list">
    <div class="task-list m-des">
      <!-- <div class="header">
        <el-row class="tc">
          <el-col :span="6" class="tl">任务名称</el-col>
          <el-col :span="5">截止时间</el-col>
          <el-col :span="4">剩余天数</el-col>
          <el-col :span="3">负责人</el-col>
          <el-col :span="3">优先级</el-col>
          <el-col :span="3">状态</el-col>
        </el-row>
      </div>-->

      <!-- 一级 -->
      <div class="item mt-20" v-for="item in dataList" :key="item.taskId">
        <!-- <h2><span class="g-mark mr-10">23</span>展览策划</h2> -->
        <h2 @mouseenter="item.btnFlag = true" @mouseleave="item.btnFlag = false">
          <span class="g-pointer" @click="item.showMore=!item.showMore">
            <i v-show="item.btnFlag || !item.showMore" class="el-icon primary" :class="{'el-icon-arrow-right': !item.showMore, 'el-icon-arrow-down': item.showMore}"></i>
            <span style="margin-left: 20px">{{item.taskName}}</span>
            <!-- <el-badge class="g-mark ml-10" :value="item.lists.length" type="info" /> -->
          </span>

          <!-- <i class="el-icon el-icon-arrow-up primary"></i> -->
        </h2>

        <!-- 二级 -->
        <div v-if="item.showMore">
          <draggable class="list-box" v-model="item.lists" draggable=".itemDrag" :group="groupA" @change="dragChange($event,item)">
            <div class="item-child itemDrag" v-for="v in item.lists" :key="v.taskId" @mouseenter="v.assignerNameFalg = true" @mouseleave="v.assignerNameFalg = false" :class="{'tip warning': v.priority === '2', 'tip rush': v.priority === '3'}">
              <el-row class="item-task tc g-pointer" :class="{'is-checked': v.collectStatus === '2'}" @click.native="showDetailDialog(v.taskId)">
                <el-col :span="17" class="title-box tl">
                  <label class="my-checkbox el-checkbox__input" :class="{'is-checked': v.collectStatus === '2'}" @click.stop="toggleCheck(v)">
                    <span class="el-checkbox__inner"></span>
                  </label>
                  <!-- <el-checkbox @change="toggleCheck(v)"></el-checkbox> -->
                  <span class="title my-check-title ell" :class="{'is-checked': v.collectStatus === '2'}">
                    {{v.taskName}}
                    <i>
                      {{v.kidsCount > 0 ? '('+v.kidCompleteNum+'/'+v.kidsCount+')' : ''}}
                      <svg-icon icon-class="fujian" class-name="icon-add" v-if="v.relativeId" style="font-size: 16px;position:relative;top:2px;" />
                    </i>
                  </span>
                </el-col>

                <!-- 截止时间 -->
                <!-- | dateFilter('截止') -->
                <el-col :span="3" class="tl" :class="{'m-danger':v.collectStatus==='3'}" v-if="v.deadline">{{v.deadline }}</el-col>
                <el-col :span="3" class="tl" :class="{'m-danger':v.collectStatus==='3'}" v-else>-</el-col>

                <!-- 剩余天数 -->
                <!-- <el-col :span="4">{{v.ext2 ? v.ext2+'天' : '-'}}</el-col> -->

                <!-- 负责人 -->
                <el-col :span="3" class="tr">
                  <el-tooltip v-if="v.assignerName" :value="v.assignerNameFalg" effect="dark" :content="v.assignerName" placement="top">
                    <div style="text-align: left">
                      <img class="g-pic small mr-10" :src="v.assignerImage||''" alt :onerror="defaultHeadImg">
                      <span>{{v.assignerName}}</span>
                    </div>
                  </el-tooltip>
                  <!-- <span>{{v.assignerName || '-'}}</span> -->
                </el-col>

                <!-- 优先级 -->
                <!-- 1:普通2:紧急3:非常紧急 -->
                <!-- <el-col :span="3">
                <template>
                  <span :class="{'m-warning': v.priority==='2', 'm-danger': v.priority==='3'}">{{v.priority | priorityFilter}}</span>
                </template>
              </el-col>-->

                <!-- 状态 -->
                <!-- collectStatus 1未完成  2已完成 3已逾期 -->
                <!-- <el-col :span="3">
                <span :class="{'m-info': v.collectStatus==='2', 'm-danger': v.collectStatus==='3'}"><i class="m-circle-dot" :class="{'done': v.collectStatus==='2', 'danger': v.collectStatus==='3'}"></i>&nbsp;&nbsp;{{v.timeStatus}}</span>
              </el-col>-->
              </el-row>
            </div>
          </draggable>

          <!-- <span class="m-btn"><svg-icon icon-class="add" class-name="icon-add" />&nbsp;添加新任务</span> -->
          <!-- <cmp-task-add :itemGroup="item"></cmp-task-add> -->
          <div class="footer-add">
            <span @click="showDetailDialog('', item.taskId)">添加新任务</span>
            <!-- <el-button type="primary" @click="showDetailDialog('', item.taskId)">添加新任务</el-button> -->
          </div>
        </div>
      </div>
    </div>

    <cmp-task-detail ref="dialogPro" @getTask="getDataList"></cmp-task-detail>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

// import bus from '@/utils/bus'
// import cmpTaskAdd from '@cmp/task-add'
import cmpTaskDetail from './dialog/dialog-task-detail'
export default {
  components: {
    draggable,
    // cmpTaskAdd,
    cmpTaskDetail
  },
  data() {
    return {
      defaultHeadImg: this.$store.state.app.defaultHeadImg,
      dataList: [],
      groupA: {
        name: "itxst",
        pull: true,  //可以拖出
        put: true,   //可以拖入
      },
    }
  },
  methods: {
    // 获取列表 名称不可修改
    getDataList() {
      this.$http
        .post('/projectTask/getTaskListView', {
          blockId: this.$route.query.projectId
        })
        .then(res => {
          if (res.success) {
            this.dataList = res.result
            this.dataList.forEach(item => {
              this.$set(item, 'showMore', true)
              this.$set(item, 'btnFlag', false)
              item.lists.map(it => {
                this.$set(it, 'assignerNameFalg', false)

              })

            })
          } else {
            this.$message.error(res.message)
          }
        })
    },
    dragChange(evt, itemGroup) {
      this.$nextTick(() => {
        // 新增
        if (evt.added) {
          console.log('新增')
          console.log(evt, evt.added.newIndex, itemGroup, itemGroup.lists)
          // 解决处理快速拖动的bug
          if (
            itemGroup.lists[evt.added.newIndex - 1] &&
            itemGroup.lists[evt.added.newIndex - 1].taskId ===
            evt.added.element.taskId
          ) {
            evt.added.newIndex -= 1
          }
          this.changeList({
            taskId: evt.added.element.taskId, //	需移动任务ID
            parentId: itemGroup.taskId, //	待移动到父级Id  (看板ID)
            ext2: evt.added.newIndex - 1,
            sort: itemGroup.lists[evt.added.newIndex - 1]
              ? itemGroup.lists[evt.added.newIndex - 1].taskId
              : '' //	待移动到前一位任务ID
          })
        }
        // 移除
        // if(evt.removed) {
        // }
        // 移动
        if (evt.moved) {
          console.log('移动')
          console.log(evt, itemGroup)
          if (
            itemGroup.lists[evt.moved.newIndex - 1] &&
            itemGroup.lists[evt.moved.newIndex - 1].taskId ===
            evt.moved.element.taskId
          ) {
            evt.moved.newIndex -= 1
          }
          this.changeList({
            taskId: evt.moved.element.taskId, //	需移动任务ID
            parentId: itemGroup.taskId, //	待移动到父级Id  (看板ID)
            ext2: evt.moved.newIndex - 1,
            sort: itemGroup.lists[evt.moved.newIndex - 1]
              ? itemGroup.lists[evt.moved.newIndex - 1].taskId
              : '' //	待移动到前一位任务ID
          })
        }
      })
    },
    // 移动
    changeList(params) {
      this.$http.post('/projectTask/moveProjectTask', params).then(res => {
        if (res.success) {
          // this.$message.success('移动成功')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 弹框详情
    showDetailDialog(taskId, parentTaskId) {
      if (!taskId) {
        this.$refs.dialogPro.init('', parentTaskId)
        return
      }
      this.$refs.dialogPro.init(taskId)
    },
    // 完成任务
    toggleCheck(item) {
      this.$http
        .post('/projectTask/updateProjectTask', {
          taskId: item.taskId, //	任务ID
          taskName: item.taskName, //	任务名称
          collectStatus: item.collectStatus === '2' ? '1' : '2', //	任务状态((1:未完成,2:已完成,3:已延期,4:已超期)
          deadline: item.deadline, //	截止时间
          assigner: item.assigner, //	负责人
          description: item.description, //	任务描述
          priority: item.priority, //	优先级(1:普通2:紧急3:非常紧急)
          ext1: 'collectStatus' //	修改的字段名称
        })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message || '操作成功')
            item.collectStatus = item.collectStatus === '2' ? '1' : '2'
          } else {
            this.$message.error(res.message)
          }
        })
    }
  },
  created() {
    this.getDataList()
  },
  mounted() {
    // bus.$on('globalTaskEvent', () => {
    //   this.getDataList()
    // })
  }
}
</script>

<style lang="scss" scoped>
.page-task-list {
  display: flex;
  justify-content: center;
  padding: 10px 30px;
  .task-list {
    width: 960px;
    border-radius: 4px;
    border-color: #e3e3e3;
    box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.12);
    padding-bottom: 20px;
    // padding: 30px;
    // background:#fff;
    // box-shadow:0px 1px 10px 0px rgba(238,239,245,1);
    // border-radius:4px;
    // line-height: 30px;
    .item {
      padding: 0 30px;
      background: #fff;
      box-shadow: 0px 1px 10px 0px rgba(238, 239, 245, 1);
      border-radius: 4px;
      h2 {
        line-height: 60px;
        position: relative;
        .g-pointer {
          i {
            top: 22px;
            position: absolute;
          }
        }
      }
      .item-child {
        position: relative;
        padding-left: 13px;
        line-height: 50px;
        border-bottom: solid 1px $border;
        &:first-child {
          border-top: solid 1px $border;
        }
        &.tip {
          // padding-left: 11px;
          &:before {
            // margin-top: 30px;
            display: block;
            content: '';
            width: 3px;
            height: 100%;
            position: absolute;
            left: 0;
          }
        }
        &.tip.warning {
          &:before {
            background: #f5a623;
          }
        }
        &.tip.rush {
          &:before {
            background: rgba(242, 81, 81, 1);
          }
        }
      }
      .title-box {
        padding-right: 100px;
        display: flex;
        align-items: baseline;
        .my-check-title {
          position: relative;
          padding-right: 70px;
          i {
            display: inline-block;
            width: 60px;
            position: absolute;
            right: 5px;
            top: 0;
          }
        }
      }
      .item-task {
        font-size: 16px;
        &.is-checked {
          color: $color6;
        }
      }
      /deep/ .cus-btn-sel {
        .el-input--suffix .el-input__inner {
          text-align: center;
        }
        ::-webkit-input-placeholder {
          /* WebKit, Blink, Edge */
          color: $primary;
        }
        :-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: $primary;
        }
        ::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: $primary;
        }
        :-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          color: $primary;
        }
      }
    }
    .footer-add {
      padding-top: 10px;
      padding-left: 34px;
      padding-bottom: 10px;
      cursor: pointer;
      span{
        color: $primary;
      }
      // padding: 20px 0;
    }
  }

  .popover-bg {
    background: #000;
  }
}
</style>
